import { render } from "./TopLevelMenu.vue?vue&type=template&id=9366968c&scoped=true"
import script from "./TopLevelMenu.vue?vue&type=script&lang=js"
export * from "./TopLevelMenu.vue?vue&type=script&lang=js"

import "./TopLevelMenu.vue?vue&type=style&index=0&id=9366968c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9366968c"]])

export default __exports__